import APIAmplify from '@aws-amplify/api';
import { updateUserById } from '@/service/userService';
import { onProjectUpdated, onUserDeleted, onUserProjectDeletedByUserId, onCorporationUpdated, onTaskParentUpdated } from '@/graphql/subscriptions';
import Utils, { isAdminUser } from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { signOut } from '@/service/authenService';
import { cloneDeep } from 'lodash';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { I18n, Storage } from 'aws-amplify';

let subscriptionEventDeleteProjectList = [];
let subscriptionDeleteUser;

export const updateLastTimeReadNotification = async (API, userId) => {
    if (!userId) {
        return;
    }

    let lastTimeReadNotification = new Date().toISOString();
    let userDetailForUpdate = {
        id: userId,
        readNotificationAt: lastTimeReadNotification
    };
    await updateUserById(API, userDetailForUpdate);
};

/**
 * onSubscriptionEventDeleteUser
 * event delete user
 * @param {*} allState
 * @param {*} mail
 */
export const onSubscriptionEventDeleteUser = (allState, id) => {
    if (!id) return;
    subscriptionDeleteUser = APIAmplify.graphql({
        query: onUserDeleted,
        variables: { id: id }
    }).subscribe({
        next: resData => {
            let userData = resData?.value?.data?.onUserDeleted;
            if (
                userData &&
                !Utils.isEmptyObject(userData) &&
                userData.active === Constant.ACTIVE_FLAG.DELETED
            ) {
                signOut(allState.history);
            }
        },
        error: err => {
            console.log('onSubscriptionEventDeleteUser err', err)
        }
    });
    return subscriptionDeleteUser
};

/**
 * unSubscriptionEventDeleteUser
 * unsubscribe event delete user in corp
 */
export const unSubscriptionEventDeleteUser = () => {
    if (subscriptionDeleteUser) {
        subscriptionDeleteUser.unsubscribe();
    }
}

export const checkReloadPanelUpdateCorpDetail = (
    corpSubscription,
    corporationDetail,
    isProjectManager,
    projectInuseDetail
) => {
    if (
        !Utils.isEmptyObject(corpSubscription) &&
        (corpSubscription.deskService !== corporationDetail.deskService ||
            corpSubscription.knowledgeService !== corporationDetail.knowledgeService ||
            // corpSubscription.chatAI !== corporationDetail.chatAI ||
            // (corpSubscription.publicService !== corporationDetail.publicService &&
            //     isProjectManager &&
            //     projectInuseDetail.isDesk &&
            //     projectInuseDetail.isPublic) ||
            corpSubscription.taskManagementService !== corporationDetail.taskManagementService ||
            // corpSubscription.limitValue.maxNumOfGeneralUser !==
            //     corporationDetail.limitValue.maxNumOfGeneralUser ||
            // corpSubscription.limitValue.maxNumOfTicket !==
            //     corporationDetail.limitValue.maxNumOfTicket ||
            // corpSubscription.limitValue.maxNumOfStorage !==
            //     corporationDetail.limitValue.maxNumOfStorage || 
            corpSubscription.rootFlag !== corporationDetail.rootFlag || 
            corpSubscription.limitValue.internalQACounterSettings !== corporationDetail.limitValue.internalQACounterSettings || 
            corpSubscription.limitValue.advancedOptionSettings !== corporationDetail.limitValue.advancedOptionSettings || 
            corpSubscription.limitValue.publicWebForm !== corporationDetail.limitValue.publicWebForm || 
            corpSubscription.limitValue.emailResponseFunction !== corporationDetail.limitValue.emailResponseFunction || 
            corpSubscription.publicService !== corporationDetail.publicService || 
            corpSubscription.limitValue.knowledgeBot !== corporationDetail.limitValue.knowledgeBot || 
            corpSubscription.limitValue.synonymSearch !== corporationDetail.limitValue.synonymSearch || 
            corpSubscription.limitValue.batchCommandService !== corporationDetail.limitValue.batchCommandService || 
            corpSubscription.limitValue.convertPDF !== corporationDetail.limitValue.convertPDF ||
            corpSubscription.limitValue.chatAI !== corporationDetail.limitValue.chatAI ||
            corpSubscription.limitValue.logAnalysis !== corporationDetail.limitValue.logAnalysis ||
            corpSubscription.limitValue.ipRestriction !== corporationDetail.limitValue.ipRestriction ||
            corpSubscription.limitValue.lincenseKeyPermission !== corporationDetail.limitValue.lincenseKeyPermission ||
            corpSubscription.limitValue.aiAuto !== corporationDetail.limitValue.aiAuto
            )
    ) {
        return true;
    }
    return false;
};


/**
 * onSubscriptionEventDeleteUserInProject
 * subscription listion remove user in project
 * @param {*} allState 
 * @param {*} id 
 * @returns 
 */
export const onSubscriptionEventDeleteUserInProject = (allState, id) => {

    if (!id) return;
    let subscriptions = APIAmplify.graphql({
        query: onUserProjectDeletedByUserId,
        variables: { id2: id }
    }).subscribe({
        next: resData => {
            let userData = resData?.value?.data?.onUserProjectDeletedByUserId;
            let projectDeletedUser = userData.projectId;
            if (!projectDeletedUser) return;

            // Using prj deleted
            if (projectDeletedUser === allState?.userDetail?.projectInuse) {
                let projectBaseData = allState.projectList.find(
                    project => project.type === Constant.PROJECT_TYPE.BASE
                );
                if (!projectBaseData || Utils.isEmptyObject(projectBaseData)) return;
                localStorageUtil.setSelectedProjectType(projectBaseData.type);
                localStorageUtil.setSelectedProjectId(projectBaseData.id);
                allState.setIsOpenModalReloadPageMain(true);
            } else {
                // Not using prj deleted => Remove prj deleted from projectList
                let currentProjectListRecoilState = cloneDeep(allState.projectList);
                if (!Utils.isEmptyArray(currentProjectListRecoilState)) {
                    let newProjectList = currentProjectListRecoilState.filter(
                        project => project.id !== projectDeletedUser
                    );
                    allState.setProjectListRecoil(newProjectList);
                }
            }
        },
        error: err => {
            console.log('onSubscriptionEventDeleteUserInProject err', err)
        }
    });

    return subscriptions
};

/**
 * init subcription listen event delete project
 * @param {*} allState 
 * @param {*} projectId 
 * @returns 
 */
export const onInitSubscriptionEventDeleteProject = (allState, projectUserList) => {
    if(Utils.isEmptyArray(projectUserList)) return;
    
    projectUserList.forEach((project) => {
        onSubscriptionEventDeleteProject(allState, project.id);
    })
};

export const onSubscriptionEventDeleteProject = (allState, projectId) => {
    
    if (!projectId) return;
    
    let subscription = APIAmplify.graphql({
        query: onProjectUpdated,
        variables: { id: projectId }
    }).subscribe({
        next: resData => {
            let projectData = resData?.value?.data?.onProjectUpdated;
            if (
                projectData &&
                !Utils.isEmptyObject(projectData) &&
                projectData.active === Constant.ACTIVE_FLAG.DELETED
            ) {
                allState.setProjectDeletedSubscription(projectData);
            }
        },
        error: err => {
            console.log('onSubscriptionEventDeleteProject err', err)
        }
    });

    subscriptionEventDeleteProjectList.push({
        subscription: subscription
    });
}

export const onSubscriptionEventUpdateCorporation = (allState, corporationDetail) => {
    if(!corporationDetail.id) return;
   let subscription =  APIAmplify.graphql({
        query: onCorporationUpdated,
        variables: {id: corporationDetail.id}
    }).subscribe({
        next: resData => {
            let corporationData = resData?.value?.data.onCorporationUpdated;
            // get logo url
            if (!Utils.isEmptyString(corporationData.image)) {
                let corporationLogo = Utils.getCloudFrontUrlForCorporationLogo({
                    type: Constant.S3_FILE_TYPE.CORPORATION_LOGO_PROFILE_FILE,
                    image: corporationData.image,
                    corporationId: corporationData.organizationDomain,
                    corporationDetail: corporationData
                });
                corporationData.corporationLogo = corporationLogo;
            } else {
                corporationData.corporationLogo = Constant.LOGO_DEFAULT;
            }
            allState.setCorpSubscription(corporationData);
            if (corporationData.rootFlag !== corporationDetail.rootFlag) {
                return
            }
            allState.setCorporationDetail(prev => ({
                ...prev,
                ...corporationData
            }));
        },
        error: err => {
            console.log('onSubscriptionEventUpdateCorporation err', err)
        }
    });

    return subscription
}

export const onSubscriptionEventUpdateTask = (taskId, setTaskIdAtom, setOpenBulkActionResultPopup, enqueueSnackbar, setIsShowDialogNotiLimit) => {
    if (!taskId || Utils.getPrefixOfId(taskId) !== 'task') return;
    let subscription =  APIAmplify.graphql({
        query: onTaskParentUpdated,
        variables: {id: taskId}
    }).subscribe({
        next: async resData => {
            let taskData = resData?.value?.data.onTaskParentUpdated;
            console.log('Subscription UpdateTask >>> taskData', taskData);

            if (taskData.id !== taskId) return;
            if (taskData.status !== Constant.TASK_STATUS.DONE) return;

            const taskIfo = Utils.convertJSONDataToObject(taskData?.info);
            console.log('taskIfo', taskIfo);

            setTaskIdAtom('');
            switch(taskIfo.bulkActionType){
                case Constant.BULK_ACTION.EXPORT_CSV:
                case Constant.BULK_ACTION.HELPDESK_EXPORT_CSV:
                    const exportCsvS3CsvKey = taskIfo?.s3CsvKey
                    const LIMIT_SIZE_FILE = 100000
                    let linkFileDownload = ""

                    //show error
                    if(Utils.isEmptyString(exportCsvS3CsvKey)) return enqueueSnackbar(I18n.get("MSG-CM-API-ERROR-WHEN-EXPORT-CSV"), {
                        variant: 'error',
                        autoHideDuration: 3000
                    });
                    
                    if(Utils.isEmptyString(taskIfo?.bulkHandleTicketTotal > LIMIT_SIZE_FILE)) return enqueueSnackbar(I18n.get("MSG-CM-OVER-SIZE-FILE-ERROR-WHEN-EXPORT-CSV"), {
                        variant: 'error',
                        autoHideDuration: 3000
                    });

                    linkFileDownload = exportCsvS3CsvKey.replaceAll("public/", "")//remove public/ in s3 key
                    const csvFileName = taskIfo?.csvFileName
                    
                    const exportCsvUrl = await Storage.get(linkFileDownload, {level: "public"});
                    const exportCsvRes = await fetch(exportCsvUrl);
                    const exportCsvBlob = await exportCsvRes.blob();
                    
                    const exportCsvDownloadUrl = window.URL.createObjectURL(new Blob([exportCsvBlob]));
                    const downloadLink = document.createElement('a');

                    downloadLink.href = exportCsvDownloadUrl;
                    downloadLink.setAttribute('download', csvFileName);
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                    break
                case Constant.BULK_ACTION.EDIT_TAG_FIELD:
                case Constant.BULK_ACTION.EDIT_PUBLIC_RANGE:
                case Constant.BULK_ACTION.BACK_TO_DRAFT:
                case Constant.BULK_ACTION.SENT_TO_PUBLIC:
                case Constant.BULK_ACTION.RESTORE:
                case Constant.BULK_ACTION.SOFT_DELETE:
                case Constant.BULK_ACTION.HARD_DELETE:
                case Constant.BULK_ACTION.DUPLICATE:
                case Constant.BULK_ACTION.KNOWLEDGE_BOOKMARK_TICKET:
                    if (taskIfo?.isSearchLimit) {
                        setIsShowDialogNotiLimit(true);
                        return;
                    }
                    //funcs need show popup
                    setOpenBulkActionResultPopup({
                        isOpen: true,
                        bulkActionResult: {
                            successCount: taskIfo?.resultSuccess || 0,
                            failCount: taskIfo?.resultFail || 0
                        },
                        panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
                    })

                    break;
                // case Constant.BULK_ACTION.HELPDESK_BACK_TO_DRAFT:
                // case Constant.BULK_ACTION.HELPDESK_SENT_TO_PUBLIC:
                case Constant.BULK_ACTION.HELPDESK_DELETE:
                case Constant.BULK_ACTION.HELPDESK_RESTORE:
                case Constant.BULK_ACTION.HELPDESK_SOFT_DELETE:
                case Constant.BULK_ACTION.HELPDESK_HARD_DELETE:
                case Constant.BULK_ACTION.HELPDESK_ARCHIVE:
                case Constant.BULK_ACTION.HELPDESK_BACK_TO_NEW_SUPPORT:
                case Constant.BULK_ACTION.HELPDESK_EDIT_TAG_FIELD:
                case Constant.BULK_ACTION.HELPDESK_BOOKMARK_TICKET:
                    if (taskIfo?.isSearchLimit) {
                        setIsShowDialogNotiLimit(true);
                        return;
                    }
                    //funcs need show popup
                    setOpenBulkActionResultPopup({
                        isOpen: true,
                        bulkActionResult: {
                            successCount: taskIfo?.resultSuccess || 0,
                            failCount: taskIfo?.resultFail || 0
                        },
                        panelType: Constant.PANEL_TYPE.HELPDESK_TICKET_LIST
                    })
                    break;
                default:
                    break;
            }
            
        },
        error: err => {
            console.log('onSubscriptionEventUpdateTask err', err)
        }
    });

    return subscription
}

export const unsubscribeEventDeleteProject = () => {
    if (Utils.isEmptyArray(subscriptionEventDeleteProjectList)) {
        return;
    }
    // unsubscription all notification
    subscriptionEventDeleteProjectList.forEach(sub => {
        sub.subscription?.unsubscribe();
    });
    subscriptionEventDeleteProjectList = [];
};

export const onChangeAdminModeHandler = async (API, newAdminMode, args) => {
    let userDetail = cloneDeep(args.userDetail);
    let userSetting = userDetail?.userSetting;
    if (!Utils.isEmptyObject(userSetting)) {
        userSetting = Utils.convertJSONDataToObject(userSetting);
    } else {
        userSetting = {};
    }

    args.setAdminMode(newAdminMode);

    // update user
    userSetting.adminMode = newAdminMode;
    let userDetailForUpdate = {
        id: userDetail.id,
        userSetting: JSON.stringify(userSetting)
    };
    updateUserById(API, userDetailForUpdate).then(updateResult => {

        // update state userDetail
        updateResult.avatar = userDetail.avatar;
        args.setUserDetail(updateResult);

        let panelList = cloneDeep(args.panelList);

        const panelsExclude = [
            Constant.PANEL_TYPE.SYSTEM_MANAGEMENT,
            Constant.PANEL_TYPE.PRODUCT_MANAGEMENT
        ];
        if (newAdminMode === Constant.ADMIN_MODE.ON) panelsExclude.push(Constant.PANEL_TYPE.ROOT_LIST_ORG);
        panelList = panelList?.filter(
            panel => !panelsExclude.includes(panel.type)
        );
        args.setPanelList(panelList);
    });
};

export const setResourceLimitCorporationError = (argsAll, corporationDetail, userDetail) => {
    const limitValue = corporationDetail.limitValue;
    const isAdmin = isAdminUser(userDetail);

    if(!isAdmin || [Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail.contractType)) {
        return argsAll.setIsBeyondLimitTicket(false);
    }

    if (
        limitValue?.numOfTicket > limitValue?.maxNumOfTicket ||
        limitValue?.numOfStorage > limitValue?.maxNumOfStorage ||
        limitValue?.numOfB2CCustomer > limitValue?.maxNumOfB2CCustomer ||
        limitValue?.numOfTicketKnowledge > limitValue?.maxNumOfTicketKnowledge ||
        limitValue?.numOfInternalUser > limitValue?.maxNumOfInternalUser ||
        limitValue?.numOfGeneralProject > limitValue?.maxNumOfGeneralProject
    ) {
        argsAll.setIsBeyondLimitTicket(true);
    } else {
        argsAll.setIsBeyondLimitTicket(false);
    }
}


export const onSubscriptionEventUpdateProjectInuse = (allState, projectId) => {
    if(!projectId) return;

   let subscription =  APIAmplify.graphql({
        query: onProjectUpdated,
        variables: {id: projectId}
    }).subscribe({
        next: resData => {
            let projectData = resData?.value?.data?.onProjectUpdated;
            if (
                projectData &&
                !Utils.isEmptyObject(projectData) &&
                projectData.active === Constant.ACTIVE_FLAG.DELETED
            ) {
                if (allState.setIsShowDialogReload) {
                    allState.setIsShowDialogReload(true);
                }
            }
        },
        error: err => {
            console.log('onSubscriptionEventUpdateCorporation err', err)
        }
    });

    return subscription
}


